import Pbp from 'components/general/Pbp'
import SportCode from "components/common/SportCode";
import { DefaultRenderCompetitor } from 'components/general/Pbp'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const BkbCenterRender = ({ action }) => {
  let [a, b, c] = ['', '', ''];
  const { mirs_discipline } = useUrlFriendlyToParameters()

  if (action.competitors === undefined) {
    a = <div><SportCode discipline={mirs_discipline} entity='@ActionComment' code={action?.pbpa_Comment} /></div>
  }

  if (!action?.pbpa_Comment?.includes('ENDP') && !action?.pbpa_Comment?.includes('STARTP')) {
    b = <div>{action?.pbpa_When}</div>
  }

  if (action.pbpa_ScoreH) {
    c = <div><strong>{action?.pbpa_ScoreH} - {action?.pbpa_ScoreA}</strong></div>
  }

  return (<div className='box-center text-center'><strong>{a}{b}{c}</strong></div>);
}

const BkbRenderSide = ({ action, homeAway }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const comp = action?.competitors?.find(item => item.pbpc_code === homeAway.participant?.code)

  if (!comp) return; //do nothing if there is no competitor related to the action

  return (
    <div className="box">
      <div><DefaultRenderCompetitor comp={comp} homeAway={homeAway} action={action} /></div>
      <div>
        {action.pbpa_Action === 'JB'
          ? <><SportCode discipline={mirs_discipline} entity='@ActionRole'
            code={action?.competitors?.find(item => item.pbpc_code === homeAway.participant?.code).athletes[0].pbpat_role} />&nbsp;</>
          : <><SportCode discipline={mirs_discipline} entity='@Action' code={action?.pbpa_Action} />&nbsp;</>
        }
        <SportCode discipline={mirs_discipline} entity='@ResAction' code={action?.pbpa_Result} />&nbsp;
      </div>
    </div>
  )
}

function BkbPbp({ data, periodsOrder }) {

  const configPpb = {
    centerRender: BkbCenterRender,
    headerRender: () => { },
    sideRender: BkbRenderSide,
    layout: "points_left",
    periodsOrder: periodsOrder,
    reverseSorting: true
  }

  return (<>
    <Pbp data={data} config={configPpb} />
  </>);
}

export default BkbPbp;